<template>
  <v-col
    v-if="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'"
    cols="12"
    class="pa-0 align-center"
    style="height: 100vh; display: flex;margin-top: -70px;"
  >

    <h2 class="text-center" style="width: 100%;">
      <v-icon x-large class="mb-5">mdi-close-octagon-outline</v-icon>
      <br />
      Not available on mobile
    </h2>
  </v-col>
  <v-container v-else class="px-5 col-12 entity-tree-container">
    <material-card class="mb-0" style="margin-top: 24px;">
      <template v-slot:header>
        <div class="px-3">
          <h4 class="title font-weight-light mb-0">Games</h4>
        </div>
        <bet-limits :btn="{}" :account="{}" />

        <v-spacer />

        <game-import
          v-if="$store.state.auth.checkAccess({ key: 'game_import', value: true })"
          :is-loading="loading"
          @import="onImport"
        />
        <export style="max-width: 120px;" :fields="exportFields(headers)" :data="filteredItems" v-if="items.length > 0" />
        <select-project
          v-model="project"
          class="col-2 mt-4 game-controll-filter"
          style="max-width: 200px;"
          :project-list-custom="projectList"
          dense
        />
        <v-btn @click="loadGames()" icon class="mt-1 mr-3" :loading="loading" :disabled="loading">
          <v-icon>refresh</v-icon>
        </v-btn>
        <v-btn @click="saveGame()" icon class="mt-1 mr-3" :disabled="loading || isEmpty(editItems)" :loading="loading">
          <v-icon>save</v-icon>
        </v-btn>

      </template>
      <v-data-table
        class="col-12 mt-2 mb-0 ml-0 mr-0 pa-0"
        :loading="loading"
        :headers="headers"
        :items="filteredItems"
        :items-per-page="500"
        :footer-props="{'items-per-page-options': [500,1000, 2000, 3000, 4000, 5000, -1]}"
        :height="`calc(100vh - 180px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
        fixed-header
      >
        <template v-slot:body.prepend>
          <tr v-if="Object.keys(filters).length > 0" class="report-filter-row grey lighten-3">
            <td
              v-for="header in headers"
              :key="header.text"
            >
              <v-select
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
                hide-details
                dense
                small
                multiple
                clearable
                persistent-hint
                single-line
                class="data-table-game-filter-select"
                :items="filters[header.value].values || columnValueList(header.value)"
                :style="{width: (filters[header.value] || {width: false}).width}"
                v-model="filters[header.value].data"
              >
              </v-select>
              <v-text-field
                class="data-table-game-filter-textfield"
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
                v-model="filters[header.value].data"
                :style="{width: (filters[header.value] || {width: false}).width, 'min-width': (filters[header.value] || {width: false}).width}"
                hide-details
              ></v-text-field>
              <v-combobox
                class="game-controll-filter"
                multiple
                dense
                hide-details=""
                auto-select-first
                :search-input.sync="filters[header.value].filterInput"
                @input="filters[header.value].filterInput = ''"
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'combobox'"
                v-model="filters[header.value].data"
                :style="{width: (filters[header.value] || {width: false}).width, 'min-width': (filters[header.value] || {width: false}).width}"
                :disabled="$data[filters[header.value].itemKey].length === 0"
                :items="$data[filters[header.value].itemKey].map(option => typeof option === 'string' ? option : option.text)">
                <template v-slot:selection="{ item, index }">
                  <v-chip
                    v-if="index < chipCount"
                    color="green"
                    outlined
                    small
                    light
                  >
                    <span>{{ item }}</span>
                  </v-chip>
                  <span
                    v-if="index === chipCount && filters[header.value].data.length > chipCount"
                    class="green--text caption"
                  >(+{{ filters[header.value].data.length - chipCount }} others)</span>
                </template>
              </v-combobox>

              <v-icon
                v-if="header.value === 'data.rollover_allowed' && $store.state.auth.checkAccess({ key: 'game_upsert', value: true })"
                class="float-right"
                :disabled="loading"
                @click="addNewGame"
              >
                add
              </v-icon>
            </td>
          </tr>
        </template>

        <template v-slot:item.codes="{ item }">
          <div v-if="item.code"><b>Code:</b> {{ item.code }}</div>
          <div v-if="item.code_mobile"><b>Code Mobile:</b> {{ item.code_mobile }}</div>
          <div v-if="item.code_external"><b>External:</b> {{ item.code_external }}</div>
          <div v-if="item.code_mobile_external"><b>External Mobile:</b> {{ item.code_mobile_external }}</div>
        </template>
        <template v-slot:item.data.bonus_no_play="{ item }">
          <template v-if="!editItems[item.game_id]">
            <i aria-hidden="true" class="v-icon notranslate mdi mdi-checkbox-blank-outline theme--light" style="opacity: 0.6" v-if="!item.data.bonus_no_play"></i>
            <i aria-hidden="true" class="v-icon notranslate mdi mdi-checkbox-marked theme--light" style="opacity: 0.6" v-if="item.data.bonus_no_play"></i>
          </template>
          <template v-if="editItems[item.game_id]">
            <v-checkbox
              v-model="editItems[item.game_id].data.bonus_no_play"
              hide-details
              class="ma-0 pa-0"
            ></v-checkbox>
          </template>
        </template>
        <template v-slot:item.data.loyalty_allowed="{ item }">
          <i
            v-if="!editItems[item.game_id]"
            aria-hidden="true"
            class="v-icon notranslate mdi mdi-checkbox-blank-outline theme--light"
            :class="{
              'mdi-checkbox-blank-outline': !item.data.loyalty_allowed,
              'mdi-checkbox-marked': item.data.loyalty_allowed,
            }"
            style="opacity: 0.6"
          />
          <v-checkbox
            v-else
            v-model="editItems[item.game_id].data.loyalty_allowed"
            class="ma-0 pa-0"
            hide-details
          />
        </template>
        <template v-slot:item.allow_freespins="{ item }">
          <template v-if="!editItems[item.game_id]">
            <i aria-hidden="true" class="v-icon notranslate mdi mdi-checkbox-blank-outline theme--light" style="opacity: 0.6" v-if="!item.allow_freespins"></i>
            <i aria-hidden="true" class="v-icon notranslate mdi mdi-checkbox-marked theme--light" style="opacity: 0.6" v-if="item.allow_freespins"></i>
          </template>
          <template v-if="editItems[item.game_id]">
            <v-checkbox
              v-model="editItems[item.game_id].allow_freespins"
              hide-details
              class="ma-0 pa-0"
            ></v-checkbox>
          </template>
        </template>
        <template v-slot:item.data.rollover_allowed="{ item }">

          <template v-if="!editItems[item.game_id]">
            {{ item.data.rollover_allowed }}
            <v-icon v-if="$store.state.auth.checkAccess({ key: 'game_upsert', value: true })" class="float-right" @click="toggleExtendedEditing(item)">tune</v-icon>
            <v-icon class="float-right" @click="toggleEdit(item)">mdi-pencil</v-icon>
          </template>
          <template v-if="editItems[item.game_id]">
            <div style="width: 92px;">
              <v-text-field
                v-model="editItems[item.game_id].data.rollover_allowed"
                small
                hide-details
                class="mt-0 pb-0 pt-0 float-left"
                @keypress.enter="saveGame()"
                :style="{width: 'calc(100% - 24px)'}"
              />
              <!--                append-icon="mdi-content-save"-->
              <!--                @click:append="saveGame(item)"-->
              <v-icon class="float-right mt-1" @click="toggleEdit(item)">mdi-close</v-icon>
            </div>
          </template>
        </template>

      </v-data-table>
    </material-card>
    <drawer-dialog
      v-model="isFormDialogVisible"
      width="70%"
      max-width="1200px"
      content-class="game-form-dialog"
    >
      <game-form
        v-if="isFormDialogVisible && gameBeingExtendedEdited"
        :game="gameBeingExtendedEdited"
        :brand-options="brandOptions"
        :system-options="systemOptions"
        :type-options="typeOptions"

        @close="isFormDialogVisible = false"
        @save="saveSingleGame"
      />
    </drawer-dialog>
  </v-container>
</template>

<style>
  .game-controll-filter .v-input__slot {
    height: 32px;
  }

  .data-table-game-filter-select .v-select__selections {
    height: 32px;
    overflow: hidden;
    white-space: nowrap;
  }

  .data-table-game-filter-textfield {
    max-width: 80px;
    font-size: 12px;
    padding: 0;
    margin: 0;
  }

  .game-form-dialog {
    background: #fff;
  }
</style>

<script>
  import { API } from '@/utils/api'
  import { debounce, toArray, map, cloneDeep, clone, uniq, concat, get, toString } from 'lodash'
  import BetLimits from '@/components/game/BetLimits'
  import { DrawerDialog } from '@/components/core/DrawerDialog'
  import Export from '@/components/helper/Export.vue'
  import { GameForm, GameImport } from '@/modules/games'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  export default {
    components: {
      SelectProject,
      BetLimits,
      Export,
      DrawerDialog,
      GameForm,
      GameImport
    },
    data: () => ({
      loading: true,
      project: '',
      brandsFilterD: [],
      brandsFilter: [],
      brands: [],
      brandOptions: [],
      systemOptions: [],
      typeOptions: [],
      chipCount: 1,
      editItems: {},
      gameBeingExtendedEdited: null,
      isFormDialogVisible: false,
      headers: [
        { text: 'ID', value: 'game_id', sortable: false },
        // { text: 'ExtID', value: 'external_id' },
        // { text: 'Parent ID', value: 'parent_id', sortable: false },
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Codes', value: 'codes', sortable: false },
        // { text: 'Code Mobile', value: 'code_mobile' },
        // { text: 'Code External', value: 'code_external' },
        // { text: 'Code Mobile External', value: 'code_mobile_external' },
        { text: 'Provider', value: 'system_name', sortable: false },
        { text: 'Brand', value: 'brand.name', sortable: false },
        { text: 'Freespins', value: 'allow_freespins', sortable: false },
        { text: 'Bonus No Play', value: 'data.bonus_no_play', sortable: false },
        { text: 'Loyalty Allowed', value: 'data.loyalty_allowed', sortable: false, },
        { text: 'Rollover Allowed', value: 'data.rollover_allowed', sortable: false },
      ],
      filters: {
        name: { data: [], type: 'text', width: '175px' },
        'data.bonus_no_play': { data: [], type: 'select', width: '150px', values: [ { text: 'Yes', value: true }, { text: 'No', value: false } ] },
        'allow_freespins': { data: [], type: 'select', width: '150px', values: [ { text: 'Yes', value: true }, { text: 'No', value: false } ] },
        'brand.name': { data: [], type: 'combobox', width: '250px', itemKey: 'brands', filterInput: '', },
        'system_name': { data: [], type: 'combobox', width: '250px', itemKey: 'systemOptions', filterInput: '', },
      },
      items: []
    }),

    mounted () {
      this.project = this.projectList[0].value
      // this.loadGames()
    },

    watch: {
      project: function () {
        this.loadGames()
      },
      brandsFilterD: debounce(function () {
        this.brandsFilter = this.brandsFilterD
      }, 800)
    },

    computed: {
      projectList: function () {
        return concat(this.$store.state.auth.user.settings.base ? [] : [ { text: 'Default', value: null } ], map(this.$store.state.auth.entities, (i) => ({ text: i.name, value: i.entity_id })))
      },
      filteredItems: function () {
        return this.items.filter(d => {
          return Object.keys(this.filters).every(f => {
            try {
              if (this.filters[f].data.length > 1 && typeof this.filters[f].data == 'string' && this.filters[f].data.toString().match(/^[><=!]{1,2}/)) {
                let filter = this.filters[f].data
                if (this.filters[f].data.toString().match(/^[><=!]{1,2}/)[0] == '=') filter = '=' + this.filters[f].data
                return eval((get(d, f) || '0').toString() + filter)
              }
            } catch (e) {
              return true
            }
            return this.filters[f].data.length < 1
              || ((this.filters[f].data.includes((get(d, f) || '')) && toString((get(d, f) || '')).length > 0)
                || (this.filters[f].data.includes(true) && ((get(d, f) || '').toString().toLowerCase()).length > 0)
                || (this.filters[f].data.includes(false) && ((get(d, f) || '').toString().toLowerCase()).length == 0)
                || (typeof get(d, f) != 'boolean' && ((get(d, f) || '').toString().toLowerCase()).indexOf(this.filters[f].data.toString().toLowerCase()) >= 0))
          })
        })
      },
    },

    methods: {
      columnValueList (val) {
        return this.items.map(d => d[val])
      },
      exportFields (headers) {
        return map(headers, 'value')
      },

      isEmpty (obj) {
        return Object.keys(obj).length === 0
      },

      toggleEdit (item) {
        item.edit = !item.edit
        if (!item.edit) {
          item.allow_freespins = clone(item.init.allow_freespins)
          item.data.bonus_no_play = clone(item.init.data.bonus_no_play)
          item.data.rollover_allowed = clone(item.init.data.rollover_allowed)
          item.data.loyalty_allowed = clone(item.init.data.loyalty_allowed)

          delete this.editItems[item.game_id.toString()]
        } else {
          if (!item.init) {
            item.init = cloneDeep(item)
          }
          this.editItems[item.game_id] = item
        }

        this.editItems = cloneDeep(this.editItems)
      },
      toggleExtendedEditing (item) {
        this.gameBeingExtendedEdited = item
        this.isFormDialogVisible = true
      },

      onImport (csv) {
        this.loading = true
        return API.call('/$v/game/import.json', {
          csv
        }).then(this.loadGames).finally(() => {
          this.loading = false
        })
      },

      saveGame () {
        if (this.isEmpty(this.editItems)) {
          this.$showWarning('Choose items for update')

          return
        }
        if (this.loading) {
          return
        }

        this.loading = true

        let entity_id = this.project
        return API.call('/$v/game/update.json', {
          entity_id,
          games: map(toArray(this.editItems), game => ({
            game_id: game.game_id,
            allow_freespins: game.allow_freespins,
            bonus_no_play: game.data.bonus_no_play,
            rollover_allowed: game.data.rollover_allowed,
            loyalty_allowed: game.data.loyalty_allowed,
          }))
        }).then(resp => {
          return this.loadGames()
        }).catch(e => {
        }).finally(() => {
          this.loading = false
        })
      },
      addNewGame () {
        this.gameBeingExtendedEdited = this.getEmptyGame()
        this.isFormDialogVisible = true
      },
      saveSingleGame (game) {
        this.loading = true
        return API.call('/$v/game/upsert.json', {
          entity_id: this.project,
          game,
        }).then(() => {
          this.loadGames()
          this.isFormDialogVisible = false
        }).finally(() => {
          this.loading = false
        })
      },
      loadGames () {
        this.loading = true
        let entity_id = this.project

        return API.call('/$v/game/list.json', {
          entity_id,
          all: true,
          full_data: true,
        }).then(resp => {
          this.brandOptions = resp.brands.map(brand => ({
            text: brand.name,
            value: brand.id
          }))

          this.systemOptions = resp.system.map(system => ({
            text: system.name,
            value: system.id
          }))

          this.typeOptions = resp.types

          this.brands = uniq(map(resp.data, 'brand.name'))
          this.items = resp.data
        }).catch(e => {
        }).finally(() => {
          this.editItems = {}
          this.loading = false
        })
      },
      getEmptyGame () {
        return {
          name: '',
          external_id: null,
          code: '',
          code_external: '',
          code_mobile: '',
          code_mobile_external: '',
          type: null,
          enabled: false,
          allow_freespins: false,
          data: {},
          system_id: null,
          brand_id: null
        }
      }
    }
  }
</script>
